module.exports = __webpack_public_path__ + "img/bank.1a533cab.png";